import { ReportsService } from "@/common/api.service";
import {
  FETCH_REPORTS,
  REPORT_CREATE,
  REPORT_DELETE,
  REPORT_FINAL_DOWNLOAD,
  REPORT_PREVIEW_DOWNLOAD,
  REPORT_UPDATE_LAST_ACTIVE_PATH,
  REPORT_FETCH_STATE
} from "./actions.type";
import {
  FETCH_REPORTS_END,
  FETCH_START,
  REPORT_FINAL_DOWNLOADING,
  REPORT_FINAL_DOWNLOADED,
  REPORT_PREVIEW_DOWNLOADING,
  REPORT_PREVIEW_DOWNLOADED,
  SET_COMPLETED_STEPS,
  STEP_SET_ALTERNATIVE_DESIGNS_STATE,
  REPORT_SET_CONTACT_INFO
} from "./mutations.type";

const state = {
  reports: [],
  isLoading: true,
  reportContactInfo: "",
  finalReportDownloading: false,
  reportPreviewDownloading: false
};

const getters = {
  reports(state) {
    return state.reports;
  },
  isLoading(state) {
    return state.isLoading;
  },
  finalReportDownloading(state) {
    return state.finalReportDownloading;
  },
  reportContactInfo(state) {
    return state.reportContactInfo;
  },
  reportPreviewDownloading(state) {
    return state.reportPreviewDownloading;
  }
};

const actions = {
  async [FETCH_REPORTS]({ commit }) {
    commit(FETCH_START);
    return ReportsService.get()
      .then(({ data }) => {
        commit(FETCH_REPORTS_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [REPORT_FETCH_STATE]({ commit }, id) {
    return ReportsService.show(id).then(({ data }) => {
      commit(SET_COMPLETED_STEPS, data.last_step_id);
      commit(REPORT_SET_CONTACT_INFO, data.contact_info);
      commit(STEP_SET_ALTERNATIVE_DESIGNS_STATE, data.calculated);
    });
  },
  async [REPORT_CREATE]() {
    return ReportsService.create();
  },
  async [REPORT_DELETE](context, id) {
    ReportsService.destroy(id);
    context.commit(REPORT_DELETE, id);
  },
  async [REPORT_FINAL_DOWNLOAD](context, { id, contact_info }) {
    context.commit(REPORT_FINAL_DOWNLOADING);
    ReportsService.download(id, { contact_info: contact_info }).then(() => {
      context.commit(REPORT_FINAL_DOWNLOADED);
    });
  },
  async [REPORT_PREVIEW_DOWNLOAD](context, { id, contact_info }) {
    context.commit(REPORT_PREVIEW_DOWNLOADING);
    ReportsService.downloadPreview(id, { contact_info: contact_info }).then(
      () => {
        context.commit(REPORT_PREVIEW_DOWNLOADED);
      }
    );
  },
  [REPORT_UPDATE_LAST_ACTIVE_PATH](
    context,
    { lastActivePath, id, lastStepId }
  ) {
    return ReportsService.update({
      last_active_path: lastActivePath,
      id: id,
      last_step_id: lastStepId
    });
  }
};

const mutations = {
  [FETCH_START](state) {
    state.isLoading = true;
  },
  [FETCH_REPORTS_END](state, reports) {
    state.reports = reports;
    state.isLoading = false;
  },
  [REPORT_SET_CONTACT_INFO](state, contactInfo) {
    state.reportContactInfo = contactInfo || "";
  },
  [REPORT_DELETE](state, id) {
    state.reports = state.reports.filter(r => r.id !== id);
  },
  [REPORT_FINAL_DOWNLOADING](state) {
    state.finalReportDownloading = true;
  },
  [REPORT_FINAL_DOWNLOADED](state) {
    state.finalReportDownloading = false;
  },
  [REPORT_PREVIEW_DOWNLOADING](state) {
    state.reportPreviewDownloading = true;
  },
  [REPORT_PREVIEW_DOWNLOADED](state) {
    state.reportPreviewDownloading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
